import styles from "./pageHeading.module.scss";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";

const PageHeading = ({ text, className, level, variant, alignment, id }) => {
  let heading;
  let variantClass = variant ? `page-heading--${variant}` : "";
  let newId = id ? id : "heading-" + text;

  const generateAlignment = () => {
    switch (alignment) {
      case "left":
      case "LEFT":
        return alignment
          ? `${styles["alignment--" + alignment.toLowerCase()]}`
          : "";
      case "RIGHT":
      case "right":
        return alignment
          ? `${styles["alignment--" + alignment.toLowerCase()]}`
          : "";
      default:
        return `${styles["alignment--center"]}`;
    }
  };

  switch (level) {
    case 4:
      heading = (
        <label
          className={`${className} ${
            styles[variantClass]
          } ${generateAlignment()}`}
          id={newId}
          dangerouslySetInnerHTML={createMarkup(text)}
        ></label>
      );
      break;
    case 3:
      heading = (
        <label
          className={`${className} ${
            styles[variantClass]
          } ${generateAlignment()}`}
          id={newId}
        >
          {text}
        </label>
      );
      break;
    case 2:
      heading = (
        <h2
          className={`${styles["page-heading"]} ${styles["page-heading--l2"]} ${styles[variantClass]} ${className}`}
          dangerouslySetInnerHTML={createMarkup(text)}
          id={newId}
        ></h2>
      );
      break;
    default:
      heading = (
        <h1
          className={`${styles["page-heading"]} ${variantClass} ${className} ${styles[variantClass]}`}
          id={newId}
          dangerouslySetInnerHTML={createMarkup(text)}
        ></h1>
      );
  }

  return heading;
};

PageHeading.defaultProps = {
  text: "",
  level: 1,
  className: "",
  variant: "",
};
PageHeading.propTypes = {
  text: PropTypes.string,
  level: PropTypes.number,
  className: PropTypes.string,
  id: PropTypes.string,
  variant: PropTypes.oneOf([
    "",
    "campaign",
    "section",
    "orderDetailsMainHeader",
    "orderTrackingMainHeader",
    "orderHistoryMainHeader",
    "orderDetailsMainHeader",
    "product-details-heading"
  ]),
};

export default PageHeading;
